export function isOpenForForeignAllowed(type, purpose) {
  if (!type || !purpose) return false;

  // Apartment & hotel → ANY purpose
  if (type === "apartment" || type === "hotel") {
    return true;
  }

  // House & country house → rent / daily rent
  if (
    (type === "house" || type === "country_house") &&
    (purpose === "for_rent" || purpose === "daily_rent")
  ) {
    return true;
  }

  // Commercial space → rent / daily / lease / collateral
  if (
    type === "commercial_space" &&
    ["for_rent", "daily_rent", "for_lease", "collateral"].includes(purpose)
  ) {
    return true;
  }

  return false;
}
